import React, { FC, useMemo } from "react";
import { InputField, INPUT_TYPES, View } from "@lookiero/aurora";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { Comment } from "../../../../../../domain/entities/order/Order";
import { Question, QuestionType } from "../../../../../../domain/entities/question/Question";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { style as feedbackListStyle } from "./FeedbackList.style";

interface FeedbackCommentProps {
  readonly question: Question;
  readonly comment: Comment | undefined;
  readonly onChangeField: (questionId: string, value: string) => void;
}

const FeedbackComment: FC<FeedbackCommentProps> = ({ question, comment, onChangeField }) => {
  const returnFeedbackCommentPlaceholderText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.RETURN_FEEDBACK_COMMENT_PLACEHOLDER,
  });
  const questionText = useI18nMessage({
    domain: DOMAIN,
    id: question.key,
  });

  const value = comment ? comment.content : "";

  const style = useMemo(() => feedbackListStyle(), []);

  return (
    <View key={question.id} style={style.fieldWrapper}>
      {question.type === QuestionType.COMMENT && <Text style={style.commentTitle}>{questionText}</Text>}
      <InputField
        key={question.id}
        defaultValue={value}
        label={returnFeedbackCommentPlaceholderText}
        name="comment"
        placeholder={returnFeedbackCommentPlaceholderText}
        testID="feedback-comment"
        type={INPUT_TYPES.text}
        value={value}
        multiLine
        onChange={(value) => onChangeField(question.id, value as string)}
      />
    </View>
  );
};

export { FeedbackComment };
